import fetch from 'node-fetch';
import utils from "../../universal/utils";

export const ANTICHEAT_LOADING = 'ANTICHEAT_LOADING';
export const ANTICHEAT_ERROR = 'ANTICHEAT_ERROR';
export const ANTICHEAT_FLAGGED_LOADED = 'ANTICHEAT_FLAGGED_LOADED';
export const ANTICHEAT_PLAYER_SUMMARY_LOADED = 'ANTICHEAT_PLAYER_SUMMARY_LOADED';
export const ANTICHEAT_PLAYER_OBSERVATIONS_LOADED = 'ANTICHEAT_PLAYER_OBSERVATIONS_LOADED';
export const ANTICHEAT_CLEAR_PLAYER = 'ANTICHEAT_CLEAR_PLAYER';

const basePath = utils.getEdgeBasePath();

function fetchAdmin(url, options = {}) {
  return fetch(url, { ...options, credentials: "include" });
}

async function parseAdminResponse(response) {
  let data = {};
  try {
    data = await response.json();
  } catch (error) {
    if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    throw error;
  }
  if (!response.ok || data?.ok === false) {
    throw new Error(data?.error || data?.err || data?.message || `HTTP ${response.status}`);
  }
  return data;
}

export const fetchFlaggedPlayers = ({ userId }) => {
  return async (dispatch) => {
    if (!userId) return;
    dispatch({ type: ANTICHEAT_LOADING });
    try {
      const response = await fetchAdmin(
        `${basePath}/api/v7/admin/anticheat/flagged-players/adpass/${userId}`
      );
      const data = await parseAdminResponse(response);
      dispatch({ type: ANTICHEAT_FLAGGED_LOADED, payload: data.players || [] });
    } catch (error) {
      console.error('Error fetching flagged players:', error);
      dispatch({ type: ANTICHEAT_ERROR, payload: error.message });
    }
  };
};

export const fetchPlayerSummary = ({ steamId, userId }) => {
  return async (dispatch) => {
    if (!steamId || !userId) return;
    dispatch({ type: ANTICHEAT_LOADING });
    try {
      const response = await fetchAdmin(
        `${basePath}/api/v7/admin/anticheat/player/${steamId}/summary/adpass/${userId}`
      );
      const data = await parseAdminResponse(response);
      dispatch({
        type: ANTICHEAT_PLAYER_SUMMARY_LOADED,
        payload: { steamId, summary: data.summary },
      });
    } catch (error) {
      console.error('Error fetching player summary:', error);
      dispatch({ type: ANTICHEAT_ERROR, payload: error.message });
    }
  };
};

export const fetchPlayerObservations = ({ steamId, userId }) => {
  return async (dispatch) => {
    if (!steamId || !userId) return;
    try {
      const response = await fetchAdmin(
        `${basePath}/api/v7/admin/anticheat/player/${steamId}/observations/adpass/${userId}`
      );
      const data = await parseAdminResponse(response);
      dispatch({
        type: ANTICHEAT_PLAYER_OBSERVATIONS_LOADED,
        payload: { steamId, batches: data.batches || [] },
      });
    } catch (error) {
      console.error('Error fetching player observations:', error);
      dispatch({ type: ANTICHEAT_ERROR, payload: error.message });
    }
  };
};

export const clearSelectedPlayer = () => ({
  type: ANTICHEAT_CLEAR_PLAYER,
});
